import axios from 'axios';
import {
  OrderBy,
  Order,
  GetAlpacaInfoResp,
  GetMyAlpacasResp,
  GetPreviewResp,
  GetAlpacaCountResp,
  GetStakingFeesResp,
} from './type';

export const getAlpacaInfo = async (
  id: number,
  address?: string
): Promise<GetAlpacaInfoResp | undefined> => {
  try {
    const { data } = await axios.get(
      `${process.env.VUE_APP_BACKEND_HTTP}/me/alpaca/${id}${
        address ? `?address=${address}` : ''
      }`
    );
    return data;
  } catch (err) {
    console.log(err);
  }
};

export const getAlpacaCount = async (
  address: string
): Promise<GetAlpacaCountResp | undefined> => {
  try {
    const { data } = await axios.get(
      `${process.env.VUE_APP_BACKEND_HTTP}/alpacas/count?address=${address}`
    );
    return data;
  } catch (err) {
    console.log(err);
  }
};

export const getMyAlpacas = async (
  address: string,
  offset: number,
  limit: number,
  orderBy: OrderBy,
  order: Order,
  noEgg?: boolean
): Promise<GetMyAlpacasResp | undefined> => {
  if (!address) {
    return;
  }
  try {
    return (
      await axios.get(
        `${process.env.VUE_APP_BACKEND_HTTP}/me/alpacas${
          noEgg ? '?egg=0' : ''
        }`,
        {
          params: {
            address,
            offset,
            limit,
            orderBy,
            order,
          },
        }
      )
    ).data;
  } catch (err) {
    // TODO
  }
};

export const getBreedingAlpacas = async (
  address: string,
  offset: number,
  limit: number,
  orderBy: OrderBy,
  order: Order,
  alpacaID?: number
) => {
  if (!address) {
    return;
  }
  try {
    return (
      await axios.get(`${process.env.VUE_APP_BACKEND_HTTP}/me/breeding`, {
        params: {
          address,
          offset,
          limit,
          orderBy,
          order,
          alpacaID,
        },
      })
    ).data;
  } catch (err) {
    // TODO
  }
};

export const getBreedingOtherAlpacas = async (
  address: string,
  offset: number,
  limit: number,
  orderBy: OrderBy,
  order: Order,
  alpacaID?: number
) => {
  if (!address) {
    return;
  }
  try {
    return (
      await axios.get(`${process.env.VUE_APP_BACKEND_HTTP}/me/stallions`, {
        params: {
          address,
          offset,
          limit,
          orderBy,
          order,
          alpacaID,
        },
      })
    ).data;
  } catch (err) {
    // TODO
  }
};

export const getMyOtherAlpacas = async (
  address: string,
  offset: number,
  limit: number,
  orderBy: OrderBy,
  order: Order
) => {
  if (!address) {
    return;
  }
  try {
    const { data } = await axios.get(
      `${process.env.VUE_APP_BACKEND_HTTP}/me/stallions/all`,
      {
        params: {
          address,
          offset,
          limit,
          orderBy,
          order,
        },
      }
    );
    return data;
  } catch (err) {
    // TODO
  }
};

export const getPreview = async (): Promise<GetPreviewResp | undefined> => {
  try {
    const { data } = await axios.get(
      `${process.env.VUE_APP_BACKEND_HTTP}/preview?limit=20&offset=0`
    );
    return data;
  } catch (err) {
    console.log(err);
  }
};

export const getStakingFees = async (): Promise<
  GetStakingFeesResp | undefined
> => {
  try {
    const { data } = await axios.get(
      `${process.env.VUE_APP_BACKEND_HTTP}/staking/fees`
    );
    return data;
  } catch (err) {
    console.log(err);
  }
};

export const getFarmInfo = async (pool: number): Promise<any | undefined> => {
  try {
    const { data } = await axios.get(
      `${process.env.VUE_APP_BACKEND_HTTP}/farm/info?pool=${pool}`
    );
    return data;
  } catch (err) {
    console.log(err);
  }
};

export const getUserStake = async (address: string): Promise<any> => {
  if (!address) {
    return;
  }
  try {
    const { data } = await axios.get(
      `${process.env.VUE_APP_BACKEND_HTTP}/me/stakes?address=${address}`
    );
    return data;
  } catch (err) {
    console.log(err);
  }
};

export const getQuadAlpacas = async (
  address: string,
  orderBy: OrderBy,
  order: Order
) => {
  if (!address) {
    return;
  }
  try {
    const { data } = await axios.get(
      `${process.env.VUE_APP_BACKEND_HTTP}/me/squad?`,
      {
        params: {
          address,
          orderBy,
          order,
        },
      }
    );
    return data;
  } catch (err) {
    // TODO
  }
};

export const getCityInfo = async (): Promise<any | undefined> => {
  try {
    const { data } = await axios.get(
      `${process.env.VUE_APP_BACKEND_HTTP}/alpacacity/info`
    );
    return data;
  } catch (err) {
    console.log(err);
  }
};

export const getAlpacasRecycledInfo = async (
  address: string
): Promise<any | undefined> => {
  try {
    const { data } = await axios.get(
      `${process.env.VUE_APP_BACKEND_HTTP}/me/recycled?address=${address}`
    );
    return data;
  } catch (err) {
    console.log(err);
  }
};

export const getReferralInfo = async (
  address: string
): Promise<any | undefined> => {
  try {
    const { data } = await axios.get(
      `${process.env.VUE_APP_BACKEND_HTTP}/me/referral/info?address=${address}`
    );
    return data;
  } catch (err) {
    console.log(err);
  }
};

export const getCommissionRecord = async (
  address: string,
  offset: number,
  limit: number
): Promise<any | undefined> => {
  try {
    const { data } = await axios.get(
      `${process.env.VUE_APP_BACKEND_HTTP}/me/referral/txs`,
      {
        params: {
          address,
          offset,
          limit,
        },
      }
    );
    return data;
  } catch (err) {
    console.log(err);
  }
};

export const sendReferral = async (
  referrer: string,
  sign: string
): Promise<any | undefined> => {
  try {
    const { data } = await axios.post(
      `${process.env.VUE_APP_BACKEND_HTTP}/me/referral/referrer/update`,
      {
        referrer,
        sign,
      }
    );
    return data;
  } catch (err) {
    console.log(err);
  }
};

export const getMyScarves = async (
  address: string,
  offset: number,
  limit: number
): Promise<any | undefined> => {
  if (!address) {
    return;
  }
  try {
    return (
      await axios.get(`${process.env.VUE_APP_BACKEND_HTTP}/me/wearable/scarf`, {
        params: {
          address,
          offset,
          limit,
        },
      })
    ).data;
  } catch (err) {
    // TODO
  }
};

export const getMyOhterScarves = async (
  address: string,
  offset: number,
  limit: number
): Promise<any | undefined> => {
  if (!address) {
    return;
  }
  try {
    return (
      await axios.get(
        `${process.env.VUE_APP_BACKEND_HTTP}/me/wearable/scarf/tailors`,
        {
          params: {
            address,
            offset,
            limit,
          },
        }
      )
    ).data;
  } catch (err) {
    // TODO
  }
};

export const getScarfInfo = async (
  id: number,
  address?: string
): Promise<any | undefined> => {
  try {
    const { data } = await axios.get(
      `${process.env.VUE_APP_BACKEND_HTTP}/me/wearable/scarf/${id}${
        address ? `?address=${address}` : ''
      }`
    );
    return data;
  } catch (err) {
    console.log(err);
  }
};
